import React, { useMemo } from 'react';

const rand = (a, b) => a + Math.random() * (b - a);

const Marigold = ({ size, tone }) => {
  const outer = tone === 'yellow' ? '#F9C80E' : '#FF8C00';
  const inner = tone === 'yellow' ? '#FFB703' : '#FF6B00';
  const core = tone === 'yellow' ? '#E07A00' : '#C2410C';
  const petals = Array.from({ length: 12 });
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
      {petals.map((_, i) => (
        <ellipse key={`o${i}`} cx="20" cy="7" rx="4.2" ry="7.5" fill={outer} transform={`rotate(${i * 30} 20 20)`} />
      ))}
      {petals.slice(0, 8).map((_, i) => (
        <ellipse key={`i${i}`} cx="20" cy="11" rx="3.6" ry="6" fill={inner} transform={`rotate(${i * 45 + 15} 20 20)`} />
      ))}
      <circle cx="20" cy="20" r="5" fill={core} />
      <circle cx="18.5" cy="18.5" r="1.6" fill="#FFE08A" opacity="0.8" />
    </svg>
  );
};

const Petal = ({ size, tone }) => {
  const fill = tone === 'rose' ? '#C8102E' : tone === 'yellow' ? '#FFC107' : '#FF7A00';
  const shade = tone === 'rose' ? '#8E0B20' : tone === 'yellow' ? '#E09A00' : '#D45500';
  return (
    <svg width={size} height={size * 1.4} viewBox="0 0 20 28" aria-hidden="true">
      <path d="M10 1 C17 6, 19 16, 10 27 C1 16, 3 6, 10 1 Z" fill={fill} />
      <path d="M10 3 C13 9, 13 18, 10 25" stroke={shade} strokeWidth="1" fill="none" opacity="0.6" />
    </svg>
  );
};

const MarigoldRain = ({ count = 34 }) => {
  const items = useMemo(() => Array.from({ length: count }, (_, i) => {
    const kind = Math.random() < 0.3 ? 'flower' : 'petal';
    const tone = kind === 'flower'
      ? (Math.random() < 0.5 ? 'orange' : 'yellow')
      : (Math.random() < 0.18 ? 'rose' : Math.random() < 0.5 ? 'orange' : 'yellow');
    return {
      id: i,
      kind,
      tone,
      left: rand(-2, 100),
      size: kind === 'flower' ? rand(18, 34) : rand(10, 18),
      duration: rand(10, 19),
      delay: -rand(0, 19),
      sway: rand(2.4, 4.8),
      swayDist: rand(18, 60),
      spin: rand(4, 9),
      opacity: rand(0.65, 0.95)
    };
  }), [count]);

  return (
    <div className="diwali-layer diwali-petals" data-testid="diwali-marigold-rain" aria-hidden="true">
      {items.map((p) => (
        <div
          key={p.id}
          className="diwali-petal-fall"
          style={{
            left: `${p.left}%`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            opacity: p.opacity
          }}
        >
          <div className="diwali-petal-sway" style={{ animationDuration: `${p.sway}s`, '--sway': `${p.swayDist}px` }}>
            <div className="diwali-petal-spin" style={{ animationDuration: `${p.spin}s` }}>
              {p.kind === 'flower' ? <Marigold size={p.size} tone={p.tone} /> : <Petal size={p.size} tone={p.tone} />}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MarigoldRain;
